// Transa - Mock Data for Frontend Demo

export const COMPANY_INFO = {
  name: "Transa",
  tagline: "We Deliver. You Install.",
  phone: "+61 407 502 587",
  email: "hello@transa.com.au",
  whatsapp: "+61407502587",
  serviceArea: "Metro Melbourne LGAs",
  logoUrl: "https://customer-assets.emergentagent.com/job_transa-installer/artifacts/xg39ufxn_TRANSA_com_au_logo_transparent_cropped.png"
};

export const HERO_CONTENT = {
  headline: "Stop wasting time on packaging and tip runs.",
  subheadline: "Transa provides installer-focused reverse logistics across Metro Melbourne — we collect bulky packaging from battery and electrical installs so you don't have to.",
  benefits: [
    { icon: "Truck", text: "Free up van/ute space" },
    { icon: "Clock", text: "No tip runs, no storage at home" },
    { icon: "CheckCircle", text: "Cleaner site handover" }
  ],
  trustLine: "Metro Melbourne LGAs only • Designed for installers • Simple booking"
};

export const SERVICE_MODELS = [
  {
    id: "standard",
    name: "Standard Collection",
    description: "Flexible scheduling",
    features: [
      "Pay per job",
      "We coordinate with your customer",
      "Photo confirmation after collection"
    ],
    highlighted: false
  },
  {
    id: "subscription",
    name: "Subscription",
    description: "Regular installers save more",
    features: [
      "Lower cost per job",
      "Up to 5 jobs/week",
      "Best for regular installers"
    ],
    highlighted: true
  },
  {
    id: "priority",
    name: "Priority Collection",
    description: "Faster turnaround",
    features: [
      "Premium service",
      "Urgent job support",
      "Best for busy weeks"
    ],
    highlighted: false
  }
];

export const WHAT_WE_COLLECT = {
  included: [
    "Cardboard boxes (inverter/BMS/battery boxes)",
    "Foam inserts / thermo foam packaging",
    "Plastic wrap / internal protective packaging",
    "Smaller accessory packaging related to the install"
  ],
  excluded: [
    "Not general building waste",
    "Not hazardous waste",
    "Pallets may be optional (by request)",
    "Very large jobs may require confirmation"
  ]
};

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: "Book your collection",
    description: "Submit a booking with customer details and a photo of the packaging",
    icon: "CalendarCheck"
  },
  {
    step: 2,
    title: "We coordinate",
    description: "We contact your customer directly to arrange collection",
    icon: "Phone"
  },
  {
    step: 3,
    title: "Collection complete",
    description: "We send you a photo once the packaging is collected",
    icon: "Camera"
  }
];

export const BEFORE_AFTER = {
  before: [
    "Cram van with packaging",
    "Unload at home after work",
    "Regular tip runs on weekends",
    "Lost productive time"
  ],
  after: [
    "Stack packaging at customer site",
    "Book Transa collection",
    "We coordinate with your customer",
    "Keep working on jobs"
  ]
};

export const SAVINGS_DATA = {
  title: "What this saves you (per job)",
  items: [
    { label: "Tip fees", icon: "Receipt" },
    { label: "Fuel costs", icon: "Fuel" },
    { label: "Time on tip runs", icon: "Clock" },
    { label: "Handling time at home", icon: "Home" },
    { label: "Lost productivity", icon: "TrendingDown" }
  ],
  summary: "Installers often lose ~$70–$100 per job in time and hidden costs. Transa turns this into a simple, predictable logistics service."
};

export const TESTIMONIALS = [
  {
    id: 1,
    quote: "Finally, someone who understands installer workflows. No more cramming boxes in the van or weekend tip runs.",
    author: "Battery Installer",
    location: "Northern suburbs"
  },
  {
    id: 2,
    quote: "The subscription model saves us hours every week. Our team can focus on what we do best - installing.",
    author: "Electrical Contractor",
    location: "Eastern suburbs"
  },
  {
    id: 3,
    quote: "Professional service, reliable pickups. Makes our site handovers much cleaner.",
    author: "Installer Crew Lead",
    location: "Bayside"
  }
];

export const FAQS = [
  {
    question: "What packaging do you take?",
    answer: "We collect cardboard boxes, foam inserts, thermo foam packaging, plastic wrap, and smaller accessory packaging from battery, inverter, and electrical installations."
  },
  {
    question: "Do you recycle?",
    answer: "We aim to sort and recycle through appropriate facilities where possible. We're committed to responsible disposal practices."
  },
  {
    question: "Do you take pallets?",
    answer: "Pallets may be collected by request. Please note this in your booking form and we'll confirm availability."
  },
  {
    question: "Do I need to flatten boxes?",
    answer: "Flattening boxes helps with efficient collection but isn't mandatory. Stack them neatly and we'll handle the rest."
  },
  {
    question: "Can you pick up from the install site?",
    answer: "Yes! We prefer picking up from the installation site. Just provide the address and any access instructions."
  },
  {
    question: "What if the job is outside metro Melbourne?",
    answer: "We currently service Metro Melbourne LGAs only. Register your interest for regional coverage expansion."
  },
  {
    question: "How does subscription work?",
    answer: "Subscription gives you the same pickup service (within 7 days) at a lower cost per job. Ideal for installers doing 3-5+ jobs per week."
  },
  {
    question: "What if I exceed 5 jobs per week?",
    answer: "Additional jobs beyond your subscription can be handled as standard per-job pickups or priority pickups if urgent."
  },
  {
    question: "How do you confirm pickup?",
    answer: "We confirm pickup windows via SMS and email. You'll know exactly when to expect us."
  },
  {
    question: "What if the customer asks who Transa is?",
    answer: "Simply explain: 'Transa is our logistics partner who handles packaging recovery so we can focus on your installation.'"
  }
];

export const METRO_POSTCODES = [
  "3000", "3001", "3002", "3003", "3004", "3005", "3006", "3008",
  "3010", "3011", "3012", "3013", "3015", "3016", "3018", "3019",
  "3020", "3021", "3022", "3023", "3024", "3025", "3026", "3027",
  "3028", "3029", "3030", "3031", "3032", "3033", "3034", "3036",
  "3037", "3038", "3039", "3040", "3041", "3042", "3043", "3044",
  "3045", "3046", "3047", "3048", "3049", "3050", "3051", "3052",
  "3053", "3054", "3055", "3056", "3057", "3058", "3059", "3060",
  "3061", "3062", "3063", "3064", "3065", "3066", "3067", "3068",
  "3070", "3071", "3072", "3073", "3074", "3075", "3076", "3078",
  "3079", "3081", "3082", "3083", "3084", "3085", "3086", "3087",
  "3088", "3089", "3090", "3091", "3093", "3094", "3095", "3096",
  "3097", "3099", "3101", "3102", "3103", "3104", "3105", "3106",
  "3107", "3108", "3109", "3110", "3111", "3113", "3114", "3115",
  "3116", "3121", "3122", "3123", "3124", "3125", "3126", "3127",
  "3128", "3129", "3130", "3131", "3132", "3133", "3134", "3135",
  "3136", "3137", "3138", "3139", "3140", "3141", "3142", "3143",
  "3144", "3145", "3146", "3147", "3148", "3149", "3150", "3151",
  "3152", "3153", "3154", "3155", "3156", "3158", "3159", "3160",
  "3161", "3162", "3163", "3165", "3166", "3167", "3168", "3169",
  "3170", "3171", "3172", "3173", "3174", "3175", "3177", "3178",
  "3179", "3180", "3181", "3182", "3183", "3184", "3185", "3186",
  "3187", "3188", "3189", "3190", "3191", "3192", "3193", "3194",
  "3195", "3196", "3197", "3198", "3199", "3200", "3201", "3202",
  "3204", "3205", "3206", "3207"
];

export const METRO_COUNCILS = [
  "City of Melbourne",
  "City of Yarra",
  "City of Port Phillip",
  "City of Stonnington",
  "City of Boroondara",
  "City of Monash",
  "City of Whitehorse",
  "City of Knox",
  "City of Maroondah",
  "City of Manningham",
  "City of Banyule",
  "City of Darebin",
  "City of Moreland",
  "City of Moonee Valley",
  "City of Maribyrnong",
  "City of Hobsons Bay",
  "City of Wyndham",
  "City of Brimbank",
  "City of Hume",
  "City of Whittlesea",
  "City of Nillumbik",
  "City of Glen Eira",
  "City of Bayside",
  "City of Kingston",
  "City of Greater Dandenong",
  "City of Casey",
  "City of Cardinia",
  "Shire of Yarra Ranges",
  "City of Frankston"
];

export const VOLUME_OPTIONS = [
  { value: "small", label: "Small (1-3 boxes)" },
  { value: "medium", label: "Medium (4-8 boxes)" },
  { value: "large", label: "Large (9+ boxes)" }
];

export const TIMEFRAME_OPTIONS = [
  { value: "7days", label: "Any time within 7 days" },
  { value: "48hours", label: "Within 48 hours (Priority)" }
];

export const SERVICE_LEVEL_OPTIONS = [
  { value: "standard", label: "Standard Pickup" },
  { value: "priority", label: "Priority Pickup" },
  { value: "subscription", label: "I'm a Subscription Customer" }
];

// Mock form submission handler
export const mockSubmitForm = (formType, data) => {
  console.log(`Form submitted: ${formType}`, data);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Form submitted successfully" });
    }, 800);
  });
};

// Postcode checker
export const checkPostcode = (postcode) => {
  const isServiced = METRO_POSTCODES.includes(postcode.trim());
  return {
    postcode,
    isServiced,
    message: isServiced 
      ? "Great news! Your area is serviced by Transa." 
      : "This postcode is not currently in our service area. Register your interest below."
  };
};
